import { BehaviorSubject } from 'rxjs';

const SESSION_KEY = 'completeProfileId';

const storedValue = typeof window !== 'undefined' ? (sessionStorage.getItem(SESSION_KEY) ?? '') : '';
const CompleteProfileIDSubject = new BehaviorSubject(storedValue);

export const CompleteProfileIDStore = {
  update: value => {
    if (typeof window !== 'undefined') {
      if (value) {
        sessionStorage.setItem(SESSION_KEY, value);
      } else {
        sessionStorage.removeItem(SESSION_KEY);
      }
    }
    CompleteProfileIDSubject.next(value);
  },
  subscribe: setState => CompleteProfileIDSubject.subscribe(setState),
  getValue: () => CompleteProfileIDSubject.value,
};

export default { CompleteProfileIDStore };
